import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalConfirmLogoutService } from './service/modal-confirm-logout.service';
import { Router } from '@angular/router';


import { NotificationsService } from '../notifications/service/notifications.service';
import { AuthService } from '../../../core/service/auth.service';
import { LoginService } from '../../../features/login/service/login.service';

@Component({
  selector: 'shared-modal-confirm-logout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-confirm-logout.component.html',
  styleUrl: './modal-confirm-logout.component.css'
})
export class ModalConfirmLogoutComponent {

  constructor(
    public modalConfirmLogoutService: ModalConfirmLogoutService,
    private router: Router,
    private authService: AuthService,
    private loginService: LoginService,
    private notificationsService: NotificationsService
  ) {}

  closeModal(): void {
    this.modalConfirmLogoutService.toggleModal(false);
  }

  confirmLogout(): void {
    this.loginService.logout().subscribe({
      next: () => {
        // Clear auth data
        this.authService.clearAuth();

        // Show success notification
        this.notificationsService.addNotification({
          message: 'Sesión cerrada exitosamente',
          type: 'success',
          duration: 3000
        });

        // Close modal
        this.closeModal();

        // Redirect to home page
        this.router.navigate(['/']);
      },
      error: (error) => {
        console.error('Logout error:', error);

        // Even if server returns an error, clear auth data on client side
        this.authService.clearAuth();

        // Show error notification
        this.notificationsService.addNotification({
          message: 'Error al cerrar sesión. Se ha cerrado la sesión localmente.',
          type: 'warning',
          duration: 5000
        });

        // Close modal
        this.closeModal();

        // Redirect to home page
        this.router.navigate(['/']);
      }
    });
  }
}
